import type { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { useEffect, useRef } from "react";
import { getTracking } from "./tracking";

export const useAppInsights = (): ApplicationInsights | null => {
  const ref = useRef<ApplicationInsights | null>(null);
  useEffect(() => {
    const runAsync = async () => {
      const instance = await getTracking();
      ref.current = instance;
    };
    runAsync();
  }, []);

  return ref.current;
};
